import { MatFormFieldDefaultOptions } from "@angular/material/form-field";

export const PB_FORM_FIELD_CONFIG: MatFormFieldDefaultOptions = {
	appearance: "outline",
};
